import { defineMessages } from "react-intl";

export const giftCardExpirySettingsCard = defineMessages({
  expiryDateSectionDescription: {
    id: "KqbfFa",
    defaultMessage:
      "You can set gift cards to expire after a certain time after their purchase. Remember that in some countries, gift cards expiry is prohibited by law.",
    description: "expiry date selection info message",
  },
  expiryDateTitle: {
    id: "1J/bhZ",
    defaultMessage: "Expiry date",
    description: "expiry date section header",
  },
  setExpirationPeriodTitle: {
    id: "j2l6cL",
    defaultMessage: "Set gift card expiration period",
    description: "checkbox label",
  },
  setExpirationPeriodDescription: {
    id: "ps+h1G",
    defaultMessage: "Expiration date will be automatically set, once gift card is issued",
    description: "checkbox label description",
  },
});
